// src/RoleManagement.js

import React, {useEffect, useState} from 'react';
import { Table, Button, Switch, Tooltip, Row, Col, Dropdown, Menu,Modal, Form,AutoComplete,
  Cascader,
  Checkbox,
  Input,
  InputNumber,
  Space,
  Select} from 'antd';
  import { MoreOutlined } from "@ant-design/icons";
import { ServiceUtils } from '../../../Shared/Utils/ServiceUtils';
import { alertService } from '../../../Shared/Utils/ToasterUtils';
import { useNavigate } from 'react-router-dom';
import { getDecryptSession } from '../../../Shared/Utils/CommonUtils';
import { useSharedState } from '../../../Shared/Services/WindowSizeService';
import classNames from "classnames";

const UserPermissions = () => {

  const navigate = useNavigate();
  const windowSize$ = useSharedState();

  const [permissions, setPermissions] = useState({
    tableData: {
        headerContent: [],
        bodyContent: []
    }
  });
  const [userDetails, setUserDetails] = useState({});

  useEffect(()=>{
    const session = localStorage.getItem("arcutis-user");
    const userDetails = getDecryptSession(session);
    setUserDetails(userDetails);
    if(userDetails.admin_access){
        getUserPermissions()
    }
  },[])

  
const getUserPermissions = () => {
    ServiceUtils.getRequest('permissionsList').then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let res = JSON.parse(JSON.stringify(response.data?.data));
          setPermissions(res)
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        console.log(error)
      }
    );
  }

  return (
    <div className="role-management">
      <Row style={{ width: "100%", margin: "5px" }}>
        <Col
          xs={{ flex: "100%" }}
          sm={{ flex: "100%" }}
          md={{ flex: "100%" }}
          lg={{ flex: "50%" }}
          xl={{ flex: "50%" }}
        >
          <div
            className={classNames("", {
              "search-kol-mobile":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "search-kol-mobile":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            <div></div>
          </div>
        </Col>
        <Col
          xs={{ flex: "100%" }}
          sm={{ flex: "100%" }}
          md={{ flex: "100%" }}
          lg={{ flex: "50%" }}
          xl={{ flex: "50%" }}
        >
          <div
            className={classNames("", {
              "search-kol-mobile":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "search-kol-mobile":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
          </div>
        </Col>
      </Row>
      <div
        className={classNames("", {
          "survey-container":
            windowSize$ === "lg" ||
            windowSize$ === "xl" ||
            windowSize$ === "xxl",
          "survey-container-small":
            windowSize$ === "xs" ||
            windowSize$ === "sm" ||
            windowSize$ === "md",
        })}
      >
        <Table
          columns={permissions?.headerContent}
          dataSource={permissions?.bodyContent}
          scroll={{ x: true, y: 400 }}
          pagination={false}
          bordered
        />
      </div>
    </div>
  );

}

export default UserPermissions;
